import { render } from "./PlanStart.vue?vue&type=template&id=6957dd31"
import script from "./PlanStart.vue?vue&type=script&lang=js"
export * from "./PlanStart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__